// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type PassengerDetailsContextProperties = {
  discount_card_count: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/passenger_details_context/jsonschema/2-0-0';
export const passengerDetailsContextName = 'passenger_details_context';
export class PassengerDetailsContext extends BaseTrackingContext<PassengerDetailsContextProperties> {
  constructor(properties: PassengerDetailsContextProperties) {
    super(passengerDetailsContextName, schema, properties);
  }
}
